package com.trevorwiebe.timesheet.signin.presentation.auth

data class SignInState (
    val passwordResetEmail: String = "",
    val initializingUser: Boolean = false,
    val loadingSignIn: Boolean = false,
    val signInError: String? = null,
    val passwordResetMessage: String? = null,
    val hidePasswordText: Boolean = true,
    val showSendPasswordResetDialog: Boolean = false,
    val loadingPasswordReset: Boolean = false
)